import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

import Badge from 'react-bootstrap/Badge';
import Alert from 'react-bootstrap/Alert';

import loadable from '@loadable/component';

import { Water, Recycle, Clock, Percent, PatchQuestion, Rulers, LifePreserver } from 'react-bootstrap-icons';

import GoverningBodyName from '../GoverningBodyName.js';
import SewageDischargeStationOperationalHistoryChart from '../SewageDischargeStationOperationalHistoryChart.js';
import SewageDischargeStationSpillHistoryChart from '../SewageDischargeStationSpillHistoryChart.js';
import SpillCountExplainModal from '../SpillCountExplainModal.js';

import NearBySewagePlace from '../NearBySewagePlace.js';

import CommonHeaders from '../helmet-headers/CommonHeaders.js';

const formatNumberOneDP = function(hours) {
	return Math.floor(hours*10)/10;
}

const SewageDischargeStationVolumeHistoryChart = loadable(() => import('../SewageDischargeStationVolumeHistoryChart.js'));

const OperationalSummaryComponent = function({ station, historyYears }) {


	const summary = historyYears.reduce(function(acca, historyYear, ix) {
		const yearData = station.sewageHistory[historyYear];
		const numHours = historyYear % 4 === 0 ? 8784 : 8760;

		if(!yearData) {
			return acca;
		}
		++acca.yearsWithData;

		let declaredDurationHours = parseFloat(yearData.declaredDurationHours);
		if(!isNaN(declaredDurationHours)) {
			++acca.yearsWithUptimeData;
		}
		let declaredCountedSpills = parseInt(yearData.declaredCountedSpills);
		let declaredOperationalUptime = parseInt(yearData.declaredOperationalUptime);
		let declaredVolumeM3 = parseInt(yearData.declaredVolumeM3);
		if(!isNaN(declaredVolumeM3)) {
			++acca.yearsWithM3Data;
		}

		acca.declaredVolumeM3 += !isNaN(declaredVolumeM3) ? declaredVolumeM3 : 0;
		acca.declaredDurationHours += !isNaN(declaredDurationHours) ? declaredDurationHours : 0;
		acca.declaredCountedSpills += !isNaN(declaredCountedSpills) ? declaredCountedSpills : 0;
		acca.declaredOperationalUptime += !isNaN(declaredOperationalUptime) ? declaredOperationalUptime : 0; // this should be correct after the acca
		acca.numHours += numHours;
		acca.numHoursForUptime += !isNaN(declaredOperationalUptime) ? numHours : 0;
		acca.declaredReceivingWater = acca.declaredReceivingWater ? acca.declaredReceivingWater : yearData.declaredReceivingWater;
console.log("ZZZZZZZZZZ", acca);
		return acca;
	}, {
		declaredDurationHours: 0.00,
		declaredCountedSpills: 0,
		declaredOperationalUptime: 0,
		declaredVolumeM3: 0,
		yearsWithM3Data: 0,
		numHours: 0,
		numHoursForUptime: 0,
		declaredReceivingWater: null,
		yearsWithData: 0,
		yearsWithUptimeData: 0,
		missingYears: false
	});
	summary.declaredOperationalUptime = summary.declaredOperationalUptime / summary.yearsWithUptimeData;
	summary.missingYears = (summary.yearsWithData < historyYears.length);


	const worstYear = historyYears.reduce(function(acca, historyYear) {
		const yearData = station.sewageHistory[historyYear];
		if(!yearData) {
			return acca;
		}

		const declaredDurationHours = parseFloat(yearData.declaredDurationHours)
		if(acca.declaredDurationHours < declaredDurationHours) {
			acca.declaredDurationHours = declaredDurationHours;
			acca.year = historyYear;
		}
		return acca;
	}, { declaredDurationHours: 0.00, year: null });

	const worstYearVolume = historyYears.reduce(function(acca, historyYear) {
		const yearData = station.sewageHistory[historyYear];
		if(!yearData) {
			return acca;
		}

		const declaredVolumeM3 = parseFloat(yearData.declaredVolumeM3);
		if(acca.declaredVolumeM3 < declaredVolumeM3) {
			acca.declaredVolumeM3 = declaredVolumeM3;
			acca.year = historyYear;
		}
		return acca;
	}, { declaredVolumeM3: 0.00, year: null });

	let missingDataAmount = null;
	// if(summary.declaredOperationalUptime && summary.declaredOperationalUptime < 100) {
		let missingAmountOfTimeHours = Math.floor(((100-parseFloat(summary.declaredOperationalUptime))*summary.numHoursForUptime))/100;

		missingDataAmount = <><span>
			<span className="hX-scale15em">
				<Badge pill bg="secondary"><Percent /> {formatNumberOneDP(summary.declaredOperationalUptime)}</Badge> | <Badge pill bg="secondary"><PatchQuestion /> {formatNumberOneDP(missingAmountOfTimeHours)} hours</Badge>
			</span><br />
			This monitor has been operational for {formatNumberOneDP(summary.declaredOperationalUptime)}% of its total time we have data for.<br />
			There are {missingAmountOfTimeHours} hours unaccounted for due to downtime of the monitor.
			{summary.numHours !== summary.numHoursForUptime ? <br /> : null}
			{summary.numHours !== summary.numHoursForUptime ? <span style={{fontSize: "0.8em"}}><i>Years with missing uptime data, totalling {(summary.numHours-summary.numHoursForUptime).toLocaleString()} hours, have been excluded from this calculation</i></span> : null}
		</span></>
	// }

	let volumeBadge = null;
	let olympicPools = null;
	if(summary.yearsWithM3Data) {
		olympicPools = Math.floor(parseInt(summary.declaredVolumeM3) / 2500).toLocaleString()
		volumeBadge = <span className="hX-scale15em">
			<Badge pill bg="danger"><Rulers /> {parseInt(summary.declaredVolumeM3).toLocaleString()} m3</Badge>
			{olympicPools ? <span> | </span> : null}
			{olympicPools ? <Badge pill bg="danger"><LifePreserver /> {olympicPools}</Badge> : null}
		</span>;
	}

	let metaTitle = "Sewage Report for the " + station.stationName + " monitor";
	if(station.riverName) {
		metaTitle += ", affecting '" + station.riverName + "'";
	}
	metaTitle += ".";

	//Check the sewage discharge and spill data for the {{ sewageStation.stationName }} event duration monitor{{#sewageStation.riverName}} for the {{ sewageStation.riverName }}{{/sewageStation.riverName}}.
	let metaDescription = "Check the sewage discharge and spill data for the " + station.stationName + " event duration monitor";
	if(station.riverName) {
		metaDescription += " for the " + station.riverName;	
	}
	metaDescription += ".";


	return <Row>
		<CommonHeaders
			title={metaTitle}
			description={metaDescription}
			/*Canonical handled by station handler*/
			/*townName handled by station handler*/
			/*ogType handled by station handler*/
			/*lat/lng handled by station handler*/
		/>
		<Col xs={12}>
			<center>
				{summary.missingYears ? <Alert style={{marginTop: "3px", marginBottom: "3px"}} variant="warning"><i><b>This dataset is partial</b>, and some year(s) are missing</i></Alert> : null}
				<span className="hX-scale15em">
					{summary.declaredReceivingWater ? [<Badge key="bpdcl" pill bg="danger"><Water /> {summary.declaredReceivingWater}</Badge>, <span key="bdpclspan"> | </span>] : null}<Badge pill bg="danger"><Recycle /> {summary.declaredCountedSpills || 0} Spills</Badge><span className="d-none d-md-inline"> | </span><br className="d-md-none d-sm-block" /><Badge pill bg="danger"><Clock /> {formatNumberOneDP(summary.declaredDurationHours)} hours</Badge> | <Badge pill bg="danger"><Percent /> {Math.floor(10000*(summary.declaredDurationHours/summary.numHours))/100}</Badge>
				</span><br />
				<SpillCountExplainModal /><br />
				{summary.declaredReceivingWater ? <><span>The declared body of water receiving this discharge is the "{summary.declaredReceivingWater}"</span><br /></> : null}
				This station has discharged sewage {summary.declaredCountedSpills} time(s).<br />
				The station has discharged for a total of {formatNumberOneDP(summary.declaredDurationHours)} hour(s).<br />
				This is {Math.floor(10000*(summary.declaredDurationHours/summary.numHours))/100}% of the time which we have data for.<br />
				In total: {Math.floor(summary.declaredDurationHours/24)} day(s)* of elapsed time.<br />
				{volumeBadge}
				{volumeBadge ? <br /> : null}
				{volumeBadge ? <span>
					The volume of discharge, in cubic metres (m3), was {parseInt(summary.declaredVolumeM3).toLocaleString()} m3.
					{olympicPools ? <br /> : null}
					{olympicPools ? <span>This is around {olympicPools} olympic swimming pools.</span> : null}
				</span> : null}<br />
				{missingDataAmount}
				{missingDataAmount ? <br /> : null}<br />
				{worstYear && worstYear.year ? <span>The worst year in our records for the "{station.stationName}" is {worstYear.year}, discharging sewage for {formatNumberOneDP(worstYear.declaredDurationHours)} hours of the year.</span> : null}
				{worstYear && worstYear.year && worstYearVolume && worstYearVolume.year ? <br /> : null}
				{worstYearVolume && worstYearVolume.year ? <span>The worst year in terms of volume for the "{station.stationName}" is {worstYearVolume.year}, discharging a total of {worstYearVolume.declaredVolumeM3.toLocaleString()} cubic metres.</span> : null}
			</center>
			<br />
		</Col>
		{summary.yearsWithM3Data ? <Col xs={12} md={3}></Col> : null}
		{summary.yearsWithM3Data ? <Col xs={12} md={6}><SewageDischargeStationVolumeHistoryChart sewageHistory={station.sewageHistory} /></Col> : null}
		{summary.yearsWithM3Data ? <Col xs={12} md={3}></Col> : null}
		<Col xs={12} md={6}><SewageDischargeStationSpillHistoryChart sewageHistory={station.sewageHistory} /></Col>
		<Col xs={12} md={6}><SewageDischargeStationOperationalHistoryChart sewageHistory={station.sewageHistory} /></Col>
		<Col xs={12}><span style={{fontSize: "0.6em"}}>*This is total time in days, not individual days.</span></Col>
	</Row>;
}

const YearRenderComponent = function({ station, year, yearData }) {

	const numHours = year % 4 === 0 ? 8784 : 8760;

	if(!yearData) {
		return <Row>
			<Col xs={12}>
				<b>We have no data for the {year} year</b><br />
				This could be because:
				<Row>
					<Col xs={12} md={3}></Col>
					<Col xs={12} md={6}>
						<ul>
							<li>It was not processed correctly by us</li>
							<li>It was not present in the data</li>
							<li>We link records using permit reference, it was missing for {year}</li>
						</ul>
					</Col>
					<Col xs={12} md={3}></Col>
				</Row>
			.</Col>
		</Row>;
	}

	let missingDataAmount = null;
	// if(yearData.declaredOperationalUptime && yearData.declaredOperationalUptime < 100) {
		let missingAmountOfTimeHours = Math.floor(((100-parseFloat(yearData.declaredOperationalUptime))*numHours))/100;

		const belowThreshold = parseFloat(yearData.declaredOperationalUptime) < 90;

		if(yearData.declaredOperationalUptime === null) {
			missingDataAmount = <><br /><span><i>The uptime data was not included in the data set or could not be processed.</i></span></>;
		} else {
			missingDataAmount = <><span>
				<span className="hX-scale15em">
					<Badge pill bg="secondary"><Percent /> {formatNumberOneDP(yearData.declaredOperationalUptime)}</Badge> | <Badge pill bg="secondary"><PatchQuestion /> {formatNumberOneDP(missingAmountOfTimeHours)} hours</Badge>
				</span><br />
				This monitor was operational for {formatNumberOneDP(yearData.declaredOperationalUptime)}% of the year.<br />
				Leaving {formatNumberOneDP(missingAmountOfTimeHours)} hours unaccounted for in the data.
				{belowThreshold ? <br /> : null}
				{belowThreshold ? <span>This falls below the 90% threshold where a reason should be given</span> : null}

				{yearData.declaredOperationalReason ? [
					<br key="bumper_1" />,
					<br key="bumper_2" />,
					<span key="reason_txt">The following reasons have been given for the downtime in {year}:</span>,
					<br key="bumper_3" />,
					<span key="reason_operator"><i>{yearData.declaredOperationalReason}</i></span>,
					<br key="bumper_4" />,
				] : null}

				{yearData.declaredOperationalActions ? [
					<br key="bumper_2" />,
					<span key="reason_txt">The following description has been given for downtime related actions intended, or taken, by the operator in {year}:</span>,
					<br key="bumper_3" />,
					<span key="reason_operator"><i>{yearData.declaredOperationalActions}</i></span>,
					<br key="bumper_4" />,
				] : null}
			</span></>
		}
	// }

	let unreliable = null;
	if(yearData.declaredOperationalUptime < 75) {
		unreliable = <Alert variant="warning" style={{marginTop: "4px", marginBottom: "4px"}}><b>Note: Data is potentially unreliable in {yearData.year}</b><br />{yearData.declaredOperationalUptime === null ? <span>The uptime was not reported or is missing</span> : <span>Due to high unavailability of the monitor</span>}</Alert>;
	}


	let volumeBadge = null;
	let olympicPools = null;
	if(yearData.declaredVolumeM3) {
		olympicPools = Math.floor(parseInt(yearData.declaredVolumeM3) / 2500).toLocaleString()
		volumeBadge = <span className="hX-scale15em">
			<Badge pill bg="danger"><Rulers /> {parseInt(yearData.declaredVolumeM3).toLocaleString()} m3</Badge>
			{olympicPools ? <span> | </span> : null}
			{olympicPools ? <Badge pill bg="danger"><LifePreserver /> {olympicPools}</Badge> : null}
		</span>;
	}


	return <Row>
		<Col xs={12} md={8}>
			<center>
				{unreliable}
				<span className="hX-scale15em">
					{yearData.declaredReceivingWater ? [<Badge key="bpdcl" pill bg="danger"><Water /> {yearData.declaredReceivingWater}</Badge>, <span key="bdpclspan"> | </span>] : null}<Badge pill bg="danger"><Recycle /> {yearData.declaredCountedSpills || "0"} Spills</Badge><span className="d-none d-md-inline"> | </span><br className="d-md-none d-sm-block" /><Badge pill bg="danger"><Clock /> {formatNumberOneDP(yearData.declaredDurationHours)} hours</Badge> | <Badge pill bg="danger"><Percent /> {Math.floor(10000*(yearData.declaredDurationHours/numHours))/100}</Badge>
				</span><br />
				{yearData.declaredReceivingWater ? <><span>The declared body of water receiving this discharge is the "{yearData.declaredReceivingWater}"</span><br /></> : null}
				This station discharged sewage {yearData.declaredCountedSpills} time(s) during {yearData.year}.<br />
				The station discharged for a total of {formatNumberOneDP(yearData.declaredDurationHours)} hour(s).<br />
				This is around {Math.floor(yearData.declaredDurationHours/24)} day(s)* or {Math.floor(10000*(yearData.declaredDurationHours/numHours))/100}% of the year.<br />
				{yearData.declaredHighSpillFreqReason ? <span><br />
					The following reasons have been given for the high spill frequency in {yearData.year}:<br />
					<i>{yearData.declaredHighSpillFreqReason}</i>
					<br />
				</span> : null}
				{yearData.declaredHighSpillFreqAction ? <span><br />
					The following comments have been given on the station operators intended actions:<br />
					<i>{yearData.declaredHighSpillFreqAction}</i>
					<br />
				</span> : null}
				{volumeBadge}
				{volumeBadge ? <br /> : null}
				{volumeBadge ? <span>
					The volume of discharge, in cubic metres (m3), was {parseInt(yearData.declaredVolumeM3).toLocaleString()} m3.
					{olympicPools ? <br /> : null}
					{olympicPools ? <span>This is around {olympicPools} olympic swimming pools.</span> : null}
				</span> : null}
				<br />{missingDataAmount}
				{missingDataAmount ? <br /> : null}
			</center>
			<br />
			<span style={{fontSize: "0.6em"}}>*This is total time in days, not individual days of the year.</span>
			<hr className="d-md-none" />
		</Col>
		<Col xs={12} md={4}>
			<h3 className="hX-blendin header-bold hX-scale15em">Permit & Governance</h3>
			<Table striped bordered hover responsive>
				<thead>
					<tr>
						<th>Attribute</th>
						<th>Value</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td><b>Governing Body</b></td>
						<td><GoverningBodyName governingBody={station.governingBody} /></td>
					</tr>
					<tr>
						<td><b>Operator</b></td>
						<td>{yearData.declaredOperator}</td>
					</tr>
					<tr>
						<td><b>Primary Permit #</b></td>
						<td>{yearData.declaredPrimaryPermitId}</td>
					</tr>
					<tr>
						<td><b>Secondary Permit #</b></td>
						<td>{yearData.declaredSecondaryPermitId}</td>
					</tr>
				</tbody>
			</Table><br />
		</Col>
	</Row>;
}

const RenderStationSewageDischarge = function({ isMissingMetrics, station, qualifierType, computedQualifierType }) {

	let historyYears = [];
	if(station && station.sewageHistory) {
		historyYears = Object.keys(station.sewageHistory).sort().reverse();

		const firstYear = parseInt(historyYears[historyYears.length-1]);
		const lastYear = parseInt(historyYears[0]);

		if((firstYear+lastYear+1) !== historyYears.length) {
			// there is missing data in the middle, patch it in - it will null key and we handle it later
			console.log(firstYear, lastYear);
			historyYears = [];
			for(let year = lastYear; year >= firstYear; year--) {
				historyYears.push(year);
			}
		}
	}

	return <Row>
		<Col xs={2}><span style={{fontSize: "3em"}} className="header-bold"><Recycle /></span></Col>
		<Col xs={10}>This is a sewage discharge monitoring station, which is usually a type of Event Duration Monitor (EDM).<br />
			These stations themselves are designed to mitigate the impact of heavy rainfall by discharging, under permitted conditions, any overflow into a water body. They are often actively discharging during flood events.<br />
			This page presents the data acquired by the monitoring system for this discharge station.<br />
		</Col>
		{station.nearBySewageReports && Object.keys(station.nearBySewageReports).length > 0 ? <Col xs={12}>
			<Row>
				<Col xs={12} className="bg-secondary text-white header-bold">View Reports that include this Station</Col>
				<Col xs={12}>
					{Object.keys(station.nearBySewageReports).map(function(placeId) {
						let place = station.nearBySewageReports[placeId];
						return <NearBySewagePlace place={place} />;
					})}	
				</Col>
			</Row>
		</Col> : null}
		<Col xs={12} className="bg-dark text-white header-bold hX-scale12em">Operational Summary {historyYears.length > 0 ? <span>- {historyYears[historyYears.length-1]}-{historyYears[0]}</span> : null}</Col>
		<Col xs={12}>
			<OperationalSummaryComponent
				station={station}
				historyYears={historyYears}
			/>
		</Col>
		<Col xs={12} className="bg-dark text-white header-bold hX-scale12em">Yearly Summary</Col>
		{historyYears.length > 0 ? <Col xs={12} className="bg-secondary text-white header-bold hX-scale12em">Most Recent Year - {historyYears[0]}</Col> : null}
		{historyYears.length > 0 ? <Col xs={12}>
			<YearRenderComponent
				station={station}
				year={historyYears[0]}
				yearData={station.sewageHistory[historyYears[0]]}
			/>
		</Col> : null}
		{historyYears.length > 1 ? historyYears.reduce(function(acca, historyYear, ix) {
			if(ix > 0) {
				acca.push(<Col xs={12} className="bg-secondary text-white header-bold hX-scale12em">{historyYear}</Col>);
				acca.push(<Col xs={12}>
					<YearRenderComponent
						station={station}
						year={historyYear}
						yearData={station.sewageHistory[historyYear]}
					/>
				</Col>)
			}
			return acca;
		}, []) : null}
		<Col xs={12}>
			<hr />
			<span style={{fontSize: "0.8em"}}>
				<b>
					FloodMapper is not affiliated with this monitoring stations operator(s) or any other entities that may be mentioned on this page.<br />
					All trademarks and registered trademarks are the property of their respective owners.
				</b><br />
				<b>Operator comments are presented, unedited, as they were received by us and do not reflect our views or position</b>
			</span>
			<hr />
		</Col>
	</Row>;
};


export default RenderStationSewageDischarge;